import Modal from "react-modal";
import React, { useState, useEffect } from "react";
import Styles from "./deomform.module.scss";
import { FaUserAlt, FaPhoneAlt } from "react-icons/fa";
import { FaBabyCarriage } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { useForm, SubmitHandler } from "react-hook-form";
import { Inputs, props } from "./types";
import { Services } from "../../../../Service/service";
import { Error } from "../../../../Reusable/utils/Toast";
import { TiWorld } from "react-icons/ti";

import { Country } from "country-state-city";
import { MdEmail } from "react-icons/md";
import { GiClassicalKnowledge } from "react-icons/gi";
import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";

import useStore from "store";
Modal.setAppElement("#root");

const DemoForm: React.FC<props> = () => {
    const [courses, setCourses] = useState([]);
    const {
        setThankYouModal,
        CourseId,
        SetDemoFormBeforeLogin,
        DemoFormBeforeLogin,
        SetCourseId,
    } = useStore((item: any) => item);
    let Countries = Country.getAllCountries();
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        setError,
        formState: { errors },
    } = useForm<Inputs>({ defaultValues: { CountryCode: "" } });

    //Initial render
    useEffect(() => {
        if (!CourseId) {
            getCourses();
        }
    }, [CourseId]);

    //FETCH COURSES
    async function getCourses() {
        try {
            const courseData = await Services.getCoursesByCategory(
                "POST",
                null,
                null
            );
            setCourses(courseData.Courses);
        } catch (err) {
            Error("something went wrong");
        }
    }
    // const
    // CLOSE FORM
    const closeModal = () => {
        SetDemoFormBeforeLogin(false);
        SetCourseId("");
        setValue("CountryCode", "");
        reset();
    };

    // FORM SUBMIT
    const onSubmit: SubmitHandler<Inputs> = (data) => {

        if (Number(data.StudentAge)<2 || Number(data.StudentAge) >12) {
            setError("StudentAge", { message: "Age must be between 2 and 12" });
            return;
        }
        const country = Country.getAllCountries().find(
            (item) => item.phonecode === data.CountryCode
        );

        // Type guard: check if it's a valid CountryCode
        const isoCode = country?.isoCode?.toUpperCase() as
            | CountryCode
            | undefined;

        const phoneNumber = parsePhoneNumberFromString(
            String(data.MobileNumber),
            isoCode ?? "IN"
        );
        if (!phoneNumber?.isValid()) {
            setError("MobileNumber", { message: "Invalid Phone Number" });
            return;
        }

        let body = JSON.stringify({
            ...data,
            CourseID: CourseId ? CourseId : data.CourseID,
            MobileNumber: `${data.MobileNumber}`,
            CountryCode: `+${data.CountryCode}`,
        });

        Services.request_demo("POST", body, null)
            .then((response: any) => {
                console.log(response);
                if (response.Status === 1) {
                    closeModal();
                    setThankYouModal(true);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                console.log(err);
                Error("something went wrong please try again");
            });
    };

    return (
        <Modal
            isOpen={DemoFormBeforeLogin}
            contentLabel="Modal"
            className={Styles["modal"]}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["form-wrapper"]}>
                <header>
                    <h2>Request Demo </h2>
                    <p>
                        Fill this form to get in front of <span>Expert</span>
                    </p>
                </header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={Styles["form-control"]}>
                        <FaUserAlt className={Styles["icon"]} />
                        <input
                            {...register("ParentName", { required: true })}
                            placeholder="Your Name"
                        />
                        {errors.ParentName && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={`${Styles["form-control"]}`}>
                        <TiWorld className={Styles["icon"]} />
                        <select
                            defaultValue={""}
                            style={{ textIndent: "20px" }}
                            {...register("CountryCode", { required: true })}>
                            <option value="" disabled>
                                Select Country
                            </option>
                            {Country.getAllCountries().map((item) => (
                                <option value={item.phonecode}>
                                    &#160; {item.name}
                                </option>
                            ))}
                        </select>
                        {errors.CountryCode && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={`${Styles["form-control"]}`}>
                        <FaPhoneAlt className={Styles["icon"]} />

                        <input
                            type="number"
                            {...register("MobileNumber", {
                                required: "This field is required",
                            })}
                            placeholder="Mobile Number without country Code"
                        />
                        {errors.MobileNumber && (
                            <span className={Styles["error"]}>
                                {errors.MobileNumber.message}
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <FaUserAlt className={Styles["icon"]} />
                        <input
                            {...register("StudentName", { required: true })}
                            placeholder="Child Name"
                        />
                        {errors.StudentName && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <FaBabyCarriage className={Styles["icon"]} />
                        <input
                        type="number"
                        step={0.01}
                            {...register("StudentAge", {
                                required: "This field is required",
                               
                            })}
                            placeholder="Child Age"
                        />
                        {errors.StudentAge && (
                            <span className={Styles["error"]}>
                                {errors?.StudentAge?.message}
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <MdEmail className={Styles["icon"]} />
                        <input
                            type="email"
                            {...register("EmailID", { required: true })}
                            placeholder="Email"
                        />
                        {errors.EmailID && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                   {/* {!CourseId && (
                        <div className={Styles["form-control"]}>
                            <GiClassicalKnowledge className={Styles["icon"]} />
                            <select
                                style={{ textIndent: "20px" }}
                                {...register("CourseID", {
                                    required: true,
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    &#160; Select Course
                                </option>
                                {courses.map((item: any) => (
                                    <option value={item?.CourseID}>
                                        &#160; {item?.CourseName}
                                    </option>
                                ))}
                            </select>
                            {errors.CourseID && (
                                <span className={Styles["error"]}>
                                    This field is required
                                </span>
                            )}
                        </div>
                   )} */}

                    <div className={Styles["buttons"]}>
                        <button type="submit" className={Styles["submit"]}>
                            Submit
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            className={Styles["close"]}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
export default DemoForm;
